import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Locked16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M4.10674 7.69231C4.03848 7.69231 3.98315 7.74779 3.98315 7.81624V13.8889C3.98315 13.9573 4.03848 14.0128 4.10674 14.0128H11.8933C11.9615 14.0128 12.0169 13.9573 12.0169 13.8889V7.81624C12.0169 7.74779 11.9615 7.69231 11.8933 7.69231H4.10674ZM2.5 7.81624C2.5 6.92645 3.21936 6.20513 4.10674 6.20513H11.8933C12.7806 6.20513 13.5 6.92645 13.5 7.81624V13.8889C13.5 14.7787 12.7806 15.5 11.8933 15.5H4.10674C3.21936 15.5 2.5 14.7787 2.5 13.8889V7.81624Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8 2.48718C7.39358 2.48718 6.81199 2.72873 6.38319 3.15871C5.95438 3.58868 5.71348 4.17184 5.71348 4.77991V6.94872C5.71348 7.35939 5.38147 7.69231 4.97191 7.69231C4.56235 7.69231 4.23034 7.35939 4.23034 6.94872V4.77991C4.23034 3.77742 4.6275 2.81598 5.33445 2.10711C6.04139 1.39824 7.00022 1 8 1C8.99978 1 9.95861 1.39824 10.6656 2.10711C11.3725 2.81598 11.7697 3.77742 11.7697 4.77991V6.94872C11.7697 7.35939 11.4376 7.69231 11.0281 7.69231C10.6185 7.69231 10.2865 7.35939 10.2865 6.94872V4.77991C10.2865 4.17184 10.0456 3.58868 9.61681 3.15871C9.18801 2.72873 8.60642 2.48718 8 2.48718Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M8 9.24145C8.40956 9.24145 8.74157 9.57437 8.74157 9.98504V11.7201C8.74157 12.1308 8.40956 12.4637 8 12.4637C7.59044 12.4637 7.25843 12.1308 7.25843 11.7201V9.98504C7.25843 9.57437 7.59044 9.24145 8 9.24145Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
